import { setSelectedCaveatId } from '../../../State/selectedCaveatId';
import { setShowCaveatModal } from '../../../State/showCaveatModal';

export default (props) => async (dispatch) => {

  dispatch(setSelectedCaveatId(props.id))
  dispatch(setShowCaveatModal(true));
  
}